import { Section } from './Section.jsx';
import { T } from '../T.jsx';

// --role-color is the per-card custom property the stylesheet reads; it is set
// inline exactly as the original markup set it.
const ROLES = [
  {
    color: 'var(--accent-r)',
    icon: '\u{1F477}',
    titleKey: 'ml_role_admin_title',
    title: 'Administrator',
    descKey: 'ml_role_admin_desc',
    desc: 'Manage users, configure institution settings, and monitor platform usage.',
    items: [
      ['ml_role_admin_1', 'User & role management'],
      ['ml_role_admin_2', 'Institution branding & themes'],
      ['ml_role_admin_3', 'Usage analytics dashboard'],
      ['ml_role_admin_4', 'LMS integration settings'],
    ],
  },
  {
    color: 'var(--accent-e)',
    icon: '\u{1F468}‍\u{1F393}',
    titleKey: 'ml_role_teacher_title',
    title: 'Teacher',
    descKey: 'ml_role_teacher_desc',
    desc: 'Create presentations, deliver live lectures, and review student engagement.',
    items: [
      ['ml_role_teacher_1', 'Slide editor & templates'],
      ['ml_role_teacher_2', 'Live lecture controls'],
      ['ml_role_teacher_3', 'AI content generation'],
      ['ml_role_teacher_4', 'Engagement & attendance reports'],
    ],
  },
  {
    color: 'var(--accent-d)',
    icon: '\u{1F393}',
    titleKey: 'ml_role_student_title',
    title: 'Student',
    descKey: 'ml_role_student_desc',
    desc: 'Follow live lectures, review materials, and interact with AI study tools.',
    items: [
      ['ml_role_student_1', 'Live lecture follow-along'],
      ['ml_role_student_2', 'Slide annotations & bookmarks'],
      ['ml_role_student_3', 'AI-generated summaries'],
      ['ml_role_student_4', 'Quiz practice & review'],
    ],
  },
];

export function Roles() {
  return (
    <Section>
      <section className="section" id="roles">
        <T k="ml_roles_label" className="section-label">User Roles</T>
        <T k="ml_roles_heading" as="h2" className="section-heading fade-in">
          Designed for Everyone in Education
        </T>
        <T k="ml_roles_intro" as="p" className="section-intro fade-in">
          Whether you manage the platform, teach courses, or attend lectures, MyLecture
          provides tools tailored to your needs.
        </T>
        <div className="roles-grid">
          {ROLES.map((role) => (
            <div className="role-card fade-in" key={role.titleKey} style={{ '--role-color': role.color }}>
              <div className="role-icon">{role.icon}</div>
              <T k={role.titleKey} as="h3">{role.title}</T>
              <T k={role.descKey} as="p">{role.desc}</T>
              <ul>
                {role.items.map(([k, label]) => (
                  <T k={k} as="li" key={k}>{label}</T>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </section>
    </Section>
  );
}
